<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-0 content-block-head mb-3">
      <div class="col p-3">
        <h4>New Vehicle</h4>
      </div>
    </div>

    <div class="col mr-3 pt-3 content-block">
      <div class="row">
        <div class="col btn-group">
          <button class='btn btn-success' (click)='saveVehicle()'>Save</button>
          <button class='btn btn-danger' (click)='cancelVehicle()'>Cancel</button>
        </div>
      </div>
      <!-- <app-dvla-reg [registration]='this.vehicleDetails.vehicle.registration'  [vin]='this.vehicleDetails.vehicle.vinNumber'></app-dvla-reg> -->
      <app-vehicledetail-form [vehicleDetails]='this.vehicleDetails' [edit]='false'></app-vehicledetail-form>
    </div>
  </div>
</div>
